import devicesTypes from './devicesTypes';
import devicesTypesFiltered from './devicesTypesFiltered';

export default {
  devicesTypes,
  devicesTypesFiltered,
};
